import { useState, useRef, useEffect } from "react";
import GetIcon from "../../../../utils/Icon";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import ConfigureColumns from "./ConfigureColumns";
import EditItemModal from "./EditItemModal";

const Table = ({ setitem_Rows, item_Rows, onSplitItem, currentSelectRow, tabData, scannedSerial }) => {
  const tableRef = useRef(null);
  const [error, setError] = useState('');
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showError, setShowError] = useState(false);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [full_Item_Detail, setfull_Item_Detail] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = item_Rows.slice(indexOfFirstRow, indexOfLastRow);
  
  const initialColumns = [
    { key: 'action', name: 'Action', width: '5%', selected: true },
    { key: 'sno', name: 'No.', width: '4%', selected: true },
    { key: 'item_code', name: 'Item Code', width: '13%', selected: true },
    { key: 'item_name', name: 'Item Name', width: '22%', selected: true },
    { key: 'grn_qty', name: 'GRN Qty', width: '5%', selected: true },
    { key: 'new_bin', name: 'Bin', width: '12%', selected: true },
    { key: 'scan_qty', name: 'Scan Qty', width: '5%', selected: true },
    { key: 'rate', name: 'Rate', width: '10%', selected: true },
    { key: 'amount', name: 'Amount', width: '10%', selected: true },
    { key: 'batch_no', name: 'Batch No.', width: '8%', selected: false },
    { key: 'serial_numbers', name: 'Serial No.', width: '10%', selected: false },
    { key: 'expiry_date', name: 'Expiry Date', width: '10%', selected: false },
    { key: 'setting', name: 'Setting', width: '4%', selected: true },
  ];

  const [columns, setColumns] = useState(initialColumns);
  const visibleColumns = columns.filter(col => col.selected);

  const handleItemChange = (serialno) => {
    setitem_Rows(prevList => {
      const updatedList = [...prevList];
      const itemIndex = updatedList.findIndex(item => item.serial_no_used.includes(serialno));
      const matchedItem = updatedList[itemIndex];
      const updatedSerialNo = matchedItem.serial_no_used.filter(item => item != serialno);
      const UpdatescannedSerial = scannedSerial.scannedSerial.filter(item => item != serialno);
      scannedSerial.setscannedSerial(UpdatescannedSerial);
      updatedList[itemIndex] = {
        ...matchedItem,
        serial_no_used: updatedSerialNo,
        scan_qty: parseInt(matchedItem.scan_qty) - 1,
      };
      return updatedList;
    })
  }

  const getRowColor = (row) => {
    const itemRows = item_Rows.filter(r => r.item_code === row.item_code);
    const totalScanQty = itemRows.reduce((sum, r) => sum + Number(r.scan_qty), 0);
    if (totalScanQty === 0) return 'not-distributed';
    if (totalScanQty >= row.received_qty) return 'fully-distributed';
    return 'partially-distributed';
  };

  const handleSaveColumns = (updatedColumns) => {
    setColumns(updatedColumns);
    setShowColumnConfig(false);
  };

  const openColumnConfig = () => {
    setShowColumnConfig(true);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...item_Rows];
    const globalIndex = indexOfFirstRow + index;
    
    if (field === 'new_bin') {
      // Validate bin exists before updating
      // You might want to add your bin validation logic here
      updatedRows[globalIndex][field] = value;
      setitem_Rows(updatedRows);
    }
  };

  const [popIndex, setpopIndex] = useState(null);
  const openEditModal = (item, index) => {
    const filterdata = item_Rows.filter((realitem) => realitem.item_code == item.item_code && realitem.new_bin == item.new_bin);
    setpopIndex(item_Rows.findIndex((realitem) => realitem.item_code == item.item_code && realitem.new_bin == item.new_bin));
    setfull_Item_Detail(filterdata[0]);
    setCurrentItem({ ...item });
    setCurrentIndex(indexOfFirstRow + index);
    setShowEditModal(true);
  };

  useEffect(() => {
    const table = tableRef.current;
    if (!table) return;

    const cols = table.querySelectorAll("th");
    const mouseDownHandlers = new Map();

    cols.forEach((col) => {
      const existingResizer = col.querySelector(".resizer");
      if (existingResizer) {
        col.removeChild(existingResizer);
      }

      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const mouseDownHandler = (e) => {
        x = e.clientX;
        w = col.getBoundingClientRect().width;
        document.addEventListener("mousemove", mouseMoveHandler);
        document.addEventListener("mouseup", mouseUpHandler);
        col.style.userSelect = "none";
        col.style.cursor = "col-resize";
      };

      const mouseMoveHandler = (e) => {
        const dx = e.clientX - x;
        const newWidth = w + dx;
        
        if (newWidth < 50) return;
        
        const originalWidth = col.style.width || col.getAttribute('data-original-width');
        const isPercentage = originalWidth.includes('%');
        
        const widthValue = isPercentage 
          ? `${(newWidth / table.getBoundingClientRect().width) * 100}%`
          : `${newWidth}px`;
        
        col.style.width = widthValue;
        
        const colIndex = Array.from(cols).indexOf(col);
        const cells = table.querySelectorAll(`td:nth-child(${colIndex + 1})`);
        cells.forEach((cell) => {
          cell.style.width = widthValue;
        });
      };

      const mouseUpHandler = () => {
        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
        col.style.userSelect = "";
        col.style.cursor = "";
      };

      mouseDownHandlers.set(col, mouseDownHandler);
      col.setAttribute('data-original-width', col.style.width || columns[col.dataset.index]?.width || '100px');
      resizer.addEventListener("mousedown", mouseDownHandler);
    });

    return () => {
      cols.forEach((col) => {
        const resizer = col.querySelector(".resizer");
        if (resizer) {
          const handler = mouseDownHandlers.get(col);
          if (handler) {
            resizer.removeEventListener("mousedown", handler);
          }
        }
      });
    };
  }, [item_Rows, currentRows]);

  return (
    <>
      <table className="table table-bordered mb-1" style={{ borderCollapse: 'separate', borderSpacing: "0px" }} ref={tableRef}>
        <colgroup>
          {visibleColumns.map((col) => (
            <col
              key={col.key}
              style={{ width: col.width }}
              data-original-width={col.width}
            />
          ))}
        </colgroup>
        <thead className="tableHead1">
          <tr>
            {visibleColumns.map((col, index) => (
              <th
                key={col.key}
                data-index={index}
                style={{
                  width: col.width,
                  minWidth: col.width,
                  position: "relative"
                }}
              >
                {col.key === "setting" ? (
                  <div onClick={openColumnConfig} style={{ cursor: 'pointer' }}>
                    <GetIcon iconName="IoSettingsOutline" size={13} />
                  </div>
                ) : (
                  col.name
                )}
                <div className="resizer" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((row, index) => (
            <tr key={`${row.id}-${index}`} className={`${row?.new_bin == currentSelectRow?.new_bin && row?.scan_qty == currentSelectRow?.scan_qty && row?.item_code == currentSelectRow?.item_code ? 'blinkbackground' : ''} ${getRowColor(row)}`}>
              {visibleColumns.map(col => {
                if (col.key === 'action') {
                  return (
                    <td key="action" className="" style={{ verticalAlign: 'middle', textAlign: '-webkit-center', borderRight: '0px', height: '29.2px' }}>
                      <button
                        className="d-flex justify-content-center align-items-center noborder p-0"
                        style={{
                          height: '21px',
                          width: '21px',
                          borderRadius: '50%',
                          backgroundColor: '#ff8d5c'
                        }}
                        onClick={() => onSplitItem(row.id)}
                        disabled={row.scan_qty >= row.grn_qty}
                      >
                        <GetIcon iconName="FaPlus" size={12} color="#fff" />
                      </button>
                    </td>
                  );
                } else if (col.key === 'sno') {
                  return <td key="sno" className="p-0" style={{ lineHeight: '28px' }} >
                    {/* {indexOfFirstRow + index + 1} */}
                    {row.idx}
                    </td>;
                } else if (col.key === 'new_bin') {
                  return (
                    <td key="new_bin" className="p-0" style={{ height: '29.2px' }}>
                      <div style={{
                        border: focusedCell.rowIndex === indexOfFirstRow + index && focusedCell.field === 'new_bin' ? 
                          '0.3px solid #270b79' : '0px',
                        height: '100%'
                      }}>
                        <input
                          type="text"
                          className="form-control noborder"
                          style={{
                            fontSize: '0.8rem',
                            padding: '0 0.75rem',
                            height: "99%",
                            backgroundColor: 'transparent',
                            width: "99%",
                            textAlign: "center",
                            position: "relative",
                            left: "0.6px"
                          }}
                          value={row.new_bin || ''}
                          onChange={(e) => handleInputChange(index, 'new_bin', e.target.value)}
                          onFocus={() => setFocusedCell({ 
                            rowIndex: indexOfFirstRow + index, 
                            field: 'new_bin' 
                          })}
                          onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                        />
                      </div>
                    </td>
                  );
                } else if (col.key === 'rate') {
                  return <td key="rate" className="p-0" style={{ lineHeight: '28px' }} >{`₹${row.valuation_rate.toFixed(2)}`}</td>;
                } else if (col.key === 'amount') {
                  return <td key="amount" className="p-0" style={{ lineHeight: '28px' }} >{row.scan_qty == 0 ? `₹${(row.valuation_rate * row.grn_qty).toFixed(2)}` : `₹${(row.valuation_rate * row.scan_qty).toFixed(2)}`}</td>;
                } else if (col.key === "batch_no") {
                  return <td className="p-0" style={{ lineHeight: '28px' }} > {row.serial_no_used.length > 0 ? `${row[col.key]}` : ''}</td>;
                } else if (col.key === "serial_numbers") {
                  return <td className="p-0" style={{ lineHeight: '28px' }} > {row.serial_no_used.length > 1 ? `${row.serial_no_used[0]}...` : row.serial_no_used[0]}</td>;
                } else if (col.key === 'setting') {
                  return (
                    <td key="setting" className="p-0" style={{ lineHeight: '28px' }}>
                      <span onClick={() => openEditModal(row, index)}>
                        <GetIcon iconName="MdOutlineEdit" size={15} />
                      </span>
                    </td>
                  );
                } else {
                  return <td key={col.key} className="p-0" style={{ lineHeight: '28px' }} >{row[col.key]}</td>;
                }
              })}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          <Button
            className="createbtn d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
          >
            Download
          </Button>
        </div>

        <div className={`${item_Rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={item_Rows.length}
          />
        </div>

        <div className={`${item_Rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, item_Rows.length)} of {item_Rows.length} entries
          </span>
        </div>
      </div>

      <ConfigureColumns
        show={showColumnConfig}
        onClose={() => setShowColumnConfig(false)}
        onSave={handleSaveColumns}
        initialFields={columns}
      />

      <EditItemModal
        tabData={tabData}
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        full_Item_Detail={full_Item_Detail}
        itemDataReal={item_Rows[popIndex]}
        onChange={handleItemChange}
        onSave={() => { }}
      />

      <ApiResponseBox show={showError} errorMessage={error} onClose={() => setShowError(false)} />
    </>
  );
};

export default Table;